<template>
  <v-app-bar app
             flat
             elevate-on-scroll
             disable-resize-watcher
             disable-route-watcher
             height="140px"
             color="white"
             class="desktop-app-bar">
<!--    <a :href="$t('home.hkaa_link')" target="_blank">-->
<!--      <img :src="require('@/assets/logo-hkaa.png')"-->
<!--           class="hkaa-logo">-->
<!--    </a>-->
    <router-link :to="{name: 'Home'}">
      <img :src="require('@/assets/logo-canteen.png')"
           class="hkiarace-logo">
    </router-link>
    <v-spacer></v-spacer>
    <v-btn class="menu-btn" text :to="{name: 'Home'}" exact>
      {{ $t('header.home') }}
    </v-btn>
    <v-btn class="menu-btn" text :to="{name: 'Register'}" exact>
      {{ $t('header.register') }}
    </v-btn>
    <v-btn class="menu-btn" text @click="changeLocale('zh')" v-if="$i18n.locale !== 'zh'">
      中
    </v-btn>
    <v-btn class="menu-btn" text @click="changeLocale('en')" v-if="$i18n.locale !== 'en'">
      EN
    </v-btn>
  </v-app-bar>
</template>

<script>
export default {
  name: 'DesktopAppBar',
  setup(props, {root}) {
    const changeLocale = function (locale) {
      root.$cookie.set('locale', locale, {samesite: 'Strict', secure: true});
      window.location.reload();
    }

    return {
      changeLocale,
    }
  }
}
</script>

<style lang="less">
.desktop-app-bar {
  padding: 0 10rem 0 10rem;

  .hkaa-logo {
    max-width: 100px;
    max-height: 160px;
  }

  .hkiarace-logo {
    margin-left: 20px;
    width: 300px;
    max-height: 75px;
  }

  .menu-btn {
    &:before {
      background: none;
    }

    &:hover, &:focus {
      background: none;
      color: #79624c !important;
      opacity: 1.0;
    }

    &.v-btn--active {
      background: none;
      color: #79624c !important;
      opacity: 1.0;

      .v-btn__content::after {
        display: block;
        position: absolute;
        bottom: -5px;
        width: 100%;
        height: 1px;
        content: " ";
        border-bottom: 1px solid;
      }
    }
  }
}
</style>
